<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de exame bloqueado">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/exame-laboratorial/relatorio-exame-bloqueado/List'

export default {
    components: { List },
}
</script>